import {Injectable} from '@angular/core';
import {ConfirmSignInRequest, SignInRequest, SignUpRequest} from '../../interfaces/auth';
import {
  confirmResetPassword,
  confirmSignIn,
  fetchAuthSession,
  fetchUserAttributes,
  getCurrentUser,
  resetPassword,
  signIn,
  signOut,
  signUp
} from 'aws-amplify/auth';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  authStateSubject = new BehaviorSubject<boolean>(false);
  authState$ = this.authStateSubject.asObservable();

  constructor() {
  }

  async signUp(userInfo: SignUpRequest) {
    const {username, email, password} = userInfo;
    return await signUp({username: email, password});
  }

  async signIn(userInfo: SignInRequest) {
    const {password, email} = userInfo;
    return await signIn({username: email, password});
  }

  async signInWithTempPassword(confirmSignInRequest: ConfirmSignInRequest) {
    const {email, tempPassword, newPassword} = confirmSignInRequest;
    const user = await signIn({username: email, password: tempPassword});
    const {signInStep} = user?.nextStep || {};
    if (signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
      return await confirmSignIn({challengeResponse: newPassword});
    } else {
      return true;
    }
  }

  async signOut() {
    return await signOut();
  }

  /**
   * ユーザー情報を取得
   */
  async getCurrentUser() {
    return await getCurrentUser();
  }

  async getUserPermission() {
    const userAttributes = await fetchUserAttributes();
    return userAttributes?.['custom:permission'] || undefined;
  }

  async getUserProjectName() {
    const userAttributes = await fetchUserAttributes();
    return userAttributes?.['custom:projectName'] || '';
  }

  async getUserDescription() {
    const userAttributes = await fetchUserAttributes();
    return userAttributes?.['custom:description'] || '';
  }

  async getUserEmail() {
    const userAttributes = await fetchUserAttributes();
    return userAttributes?.['email'] || '';
  }

  async getJwtToken() {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString();
  }

  /**
   * パスワードをリセットして確認コードを送信
   * @param email
   */
  async resetPassword(email: string) {
    return await resetPassword({username: email});
  }

  /**
   * リセットコードを確認し、新しいパスワードを設定する
   * @param email
   * @param code
   * @param newPassword
   */
  async confirmResetPassword(email: string, code: string, newPassword: string) {
    return await confirmResetPassword({username: email, confirmationCode: code, newPassword});
  }
}
